import React, {Component} from 'react';
import './ICompanyProfile.css';
import CompanyProfileCard from './CompanyProfileCard.js'
import beliefsImage from '../../../images/individual/companyprofile/Beliefs.png';
import visionImage from '../../../images/individual/companyprofile/Vision.png';
import philosophyImage from '../../../images/individual/companyprofile/Philosophy.png';
import missionImage from '../../../images/individual/companyprofile/Mission.png';
import agricultureCover from '../../../images/individual/agriculture/AgriCover.jpg';

export default class ICompanyProfile extends Component {
	render() {
		return (
			<div className="i_company_profile_container">
				<div className="i_company_profile_title">COMPANY PROFILE</div>
				<div className="i_company_profile_subtitle_container">
					<div className="i_company_profile_subtitle">Pacific Prince International (“PPI”) is an Australian company incorporated in 1996 by Minter Ellison and Kevin Rodger & Co. It is a holding company owning subsidiaries that engage in a number of diverse business activities including property, agriculture tech, healthcare & energy. In 2001, Pacific Prince established our Singapore- based company begin operation as the headquarter for the Asia-Pacific region.</div>
				</div>
				<div className="i_company_profile_body_container">
				<CompanyProfileCard
					title="Our Vision"
					subtitle="As an integrated multi-discipline company, we aspire to create economic opportunity, growth, and impact in the communities in various countries around the world by helping our client to achieve success in business endeavors and financial security."
					image={visionImage} />
				<CompanyProfileCard
					title="Our Mission"
					subtitle="Our mission is to embrace innovations to achieve creative solutions with high efficiency and cost-effectiveness in improving the way the world works. To provide our clients with reliable business solutions with high values, in order to ensure good growth for their shareholders, whilst creating a positive community impact and delivering a competitive shareholder returns on their investments."
					image={missionImage} />
				<CompanyProfileCard
					title="Our Philosophy"
					subtitle="PPI conducts our business with high level of integrity and fairness, and a commitment towards excellency in service, profitability and sustained growth. We seek to identify unique projects and explore alternative solutions which are generated through interaction with the related parties."
					image={philosophyImage} />

				<CompanyProfileCard
					title="Our Beliefs"
					subtitle="PPI believes in the power of collaboration. As a private firm, we make proprietary investments by utilizing our own funds to venture into viable projects with good investments and business opportunities in new and untapped markets. We assemble our team of experts to actively participate in strategic management to bring the wealth of our technical experiences to fuel the business growth with firm footings in global markets."
					image={beliefsImage} />
				</div>
			</div>
		);
	}
}
